import { Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import styles from "./apiReport.module.scss";
import BurialPointDetails from "./burialPointDetails/burialPointDetails";
import BurialPointStatistic from "./burialPointStatistic/burialPointStatistic";
import UsageStatistics from "./usageStatistics/usageStatistics";
import { useTranslation } from "react-i18next";

function AnalysisReport() {
	const { t } = useTranslation();
	const [tab, setTab] = useState(0);

	const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
		setTab(newValue);
	};

	return (
		<div className={styles.container}>
			<div className={styles.title}>{t("userSystem.apiReport")}</div>
			<Tabs
				value={tab}
				onChange={handleChangeTab}
			>
				<Tab label={t("userSystem.burialPointDetails")} />
				<Tab label={t("userSystem.burialPointStatistic")} />
				<Tab label={t("userSystem.usageStatistics")} />
			</Tabs>
			{tab === 0 && <BurialPointDetails />}
			{tab === 1 && <BurialPointStatistic />}
			{tab === 2 && <UsageStatistics />}
		</div>
	);
}

export default AnalysisReport;
